import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-block.scss";
import {isMobile} from "../../../../../../sedestral/framework/utilities/IsMobile";

export class WebsiteBlackBlockComponent extends Component {
    constructor(block: {
        text: string,
        icon?: string,
        background?: string,
        color?: string,
        tiny?: boolean,
        buttons?: { name: string, color?: string, link: string }[]
    }) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackBlock} ${block.background ? s[block.background] : ``}">
                <div class="${s.case} ${block.color ? s[block.color] : ``}">
                    ${block.icon ? `<div class="${s.scoreIcon} ${s[block.icon]}"></div>` : ``}
                    <h3 class="${s.text}">
                        ${block.text}
                    </h3>
                    ${block.buttons ? `
                    <div class="${s.buttons}">
                        ${block.buttons.map(button => `
                        <a href="${button.link}" target="_blank" class="${s.button} ${button.color ? s[button.color] : ``}">
                            <div class="${s.content}">
                                ${button.name}
                            </div>
                        </a>
                        `).join(``)}
                    </div>
                    ` : ``}
                </div>
            </div>
        `;
    }

    commit() {
        let theCase = this.el(s.case);
        let score = this.el(s.scoreIcon);

        if (!isMobile() && !score.isNull()) {
            this.putListener(window, "scroll", () => {
                let top = theCase.getOffsets().top - window.innerHeight + 100;
                if (top <= 0) {
                    let translateY = Math.abs(top);
                    let scale = Math.max(3 - (translateY / 240), 1);
                    score.setStyle(`transform: scale(${scale});`);
                } else {
                    score.setStyle(`transform: scale(3);`);
                }
            });
        }

        super.commit();
    }
}